module.exports = __kbnSharedDeps_npm__;